import { render, staticRenderFns } from "./group-documents-card.vue?vue&type=template&id=b7c68136&scoped=true&"
import script from "./group-documents-card.vue?vue&type=script&lang=js&"
export * from "./group-documents-card.vue?vue&type=script&lang=js&"
import style0 from "./group-documents-card.vue?vue&type=style&index=0&id=b7c68136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c68136",
  null
  
)

export default component.exports